export default "__VITE_ASSET__CeaIaCtb__"